import type { IPagination } from '@experiences/interfaces';

import type {
    IOnPremOrganizationDto,
    IOnPremOrganizationResponse,
} from '../../common/interfaces/organization';
import {
    axiosDelete,
    get,
    post,
} from '../utility/Requests';

export const onPremOrganizationManagementUri = '/onprem/api/organization';

export function addOnPremOrganization(onPremOrganizationDto: IOnPremOrganizationDto) {
    return post(onPremOrganizationManagementUri, { body: onPremOrganizationDto });
}

export function deleteOnPremOrganization(organizationGuid: string) {
    return axiosDelete(`${onPremOrganizationManagementUri}/${organizationGuid}`);
}

export function getAllOnPremOrganizations({ pagination }: { url: string; pagination?: IPagination }) {
    return get<IOnPremOrganizationResponse>(`${onPremOrganizationManagementUri}/getAllOrganizations`, { pagination });
}
